import './Account.css';

import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonIcon, IonRow, IonText } from '@ionic/react';
import { calendarOutline, keyOutline, logOutOutline, personOutline, phonePortraitOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import ActionButton from '../../../components/button/ActionButton';
import InputItem from '../../../components/input/InputItem';
import LayoutGap from '../../../layouts/LayoutGap';
import Toolbar from '../../../layouts/Toolbar';
import LoginForm from './Forms/LoginForm';
import RegisterForm from './Forms/RegisterForm';
import PasswordRecoveryForm from './Forms/PasswordRecoveryForm';
import Activation from './Forms/RegisterForms/Activation';

interface Props {
    loginSuccess: any
}

const Account: React.FC<Props> = (props) => {
    const [activeContent, setActiveContent] = useState("login");
    const [changeButtonText1, setChangeButtonText1] = useState("ثبت نام");
    const [changeButtonText2, setChangeButtonText2] = useState("بازیابی رمز عبور");
    const [showConfirm, setShowConfirm] = useState(false);
    const [uid, setUid] = useState("");
    const [remainedTime, seRemainedTime] = useState(0);

    const changeActiveContentHandler = () => {
        if (activeContent == "login" || activeContent == "recovery") {
            setActiveContent("register")
            setChangeButtonText1("ورود")
        } else {
            setActiveContent("login")
            setChangeButtonText1("ثبت نام")
        }

        setChangeButtonText2("بازیابی رمز عبور")
    }

    const changeRecoveryContentHandler = () => {
        if (activeContent == "recovery") {
            setActiveContent("login")
            setChangeButtonText2("بازیابی رمز عبور")
        } else {
            setActiveContent("recovery")
            setChangeButtonText2("ورود")
        }

        setChangeButtonText1("ثبت نام")
    }

    const loginNoActivationHandler = (uid: string, remained: number) => {
        setUid(uid);
        seRemainedTime(remained);
        setShowConfirm(true);
    }

    const activationDoneHandler = () => {
        setShowConfirm(false);
    }

    return <div className="profile-login">
        <Toolbar title="ورود اعضا"/>

        <LayoutGap/>

        <IonContent className="main-content">
            <IonCard className="login-section">
                {activeContent == "login" ? (!showConfirm ? <LoginForm loginSuccess={props.loginSuccess} loginNoActivation={loginNoActivationHandler} /> : <Activation uid={uid} remainTime={remainedTime} activationDone={activationDoneHandler} loginSuccess={props.loginSuccess} />) : null}

                {activeContent == "register" ? <RegisterForm loginSuccess={props.loginSuccess} /> : null}

                {activeContent == "recovery" ? <PasswordRecoveryForm /> : null}
            </IonCard>

            <IonRow className="bottom-buttons ion-padding-top ion-padding-horizontal">
                <IonCol size="6">
                    <IonButton expand="block" color="secondary" onClick={() => { changeActiveContentHandler() }}>{changeButtonText1}</IonButton>
                </IonCol>
                <IonCol size="6">
                    <IonButton expand="block" color="danger" onClick={() => { changeRecoveryContentHandler() }}>{changeButtonText2}</IonButton>
                </IonCol>
            </IonRow>
        </IonContent>
    </div>;
}
export default Account